import {useContext, useEffect, useId} from 'react';
import {NavigationGuardConfig, NavigationGuardContext} from './NavigationGuardContext';

function useNavigationGuardContext() {
  const context = useContext(NavigationGuardContext);
  if (context === undefined) {
    throw new Error(
      'useRegisterNavigationGuard must be used within a NavigationGuardProvider',
    );
  }
  return context;
}

function useRegisterNavigationGuard({
  when,
  onDiscard,
  title,
  description,
  confirmLabel,
  cancelLabel,
}: NavigationGuardConfig) {
  const {registerGuard, unregisterGuard} = useNavigationGuardContext();
  const id = useId();

  useEffect(() => {
    registerGuard(id, {when, onDiscard, title, description, confirmLabel, cancelLabel});
    return () => unregisterGuard(id);
  }, [
    id,
    when,
    onDiscard,
    title,
    description,
    confirmLabel,
    cancelLabel,
    registerGuard,
    unregisterGuard,
  ]);
}

export {useRegisterNavigationGuard, useNavigationGuardContext};
